import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-notification',
  templateUrl: './confirm-notification.component.html',
  styleUrls: ['./confirm-notification.component.scss']
})
export class ConfirmNotificationComponent implements OnInit {
  message: string  = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmNotificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService
  ) {
    if (data.notifiedCount !== undefined) {
      this.message = data.notifiedCount + ' ' + (data.notifiedCount !== 1
        ? this.translateService.instant('Catalogs.catalog_shared_successfully_to_multiple_persons')
        : this.translateService.instant('Catalogs.catalog_shared_successfully_to_one_person'));
    }
  }

  ngOnInit(): void {

  }

  onClose(): void {
    this.dialogRef.close();
  }

  onDone(): void {
    this.dialogRef.close(true);
  }
}
